import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client'
//import 'semantic-ui-css/semantic.min.css';
import 'semantic-ui-less/semantic.less'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n'
import { CookiesProvider } from "react-cookie";
import { BrowserRouter } from "react-router-dom";

//ReactDOM.render(<App />, document.getElementById('root'));
const Loader = () => <div>Loading application...</div>

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(
    <CookiesProvider>
      <BrowserRouter basename={import.meta.env.VITE_BASE_URL}>
        <Suspense fallback={<Loader />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </CookiesProvider>
  );
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
